/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import UserActions from '@Actions/userActions';
import { Alert, Input } from 'antd';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

const RequestOtp = (props) => {
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [username, setUsername] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const {
    requestOtp,
    updateOtpRequested,
    requestOtpLoading,
    requestOtpFastLoading,
    otpError,
  } = props;

  const handleTurnstileCallback = (token) => {
    setTurnstileToken(token);
  };
  useEffect(() => {
    // If we have bypass cf code then it will disable the cloudflare turnstile.
    if (window.turnstile) {
      window.turnstile.render('#turnstile-element', {
        sitekey: '0x4AAAAAAAhdS1fOSzzZHT6h',
        callback: handleTurnstileCallback,
        theme: 'light',
      });
    }
  }, []);
  useEffect(() => {
    setErrorMessage(otpError);
  }, [otpError]);

  const sendOtp = () => {
    // If we have bypass cf code then it will disable the cloudflare turnstile.
    if (turnstileToken) {
      const payload = {
        username: username.trim().toLowerCase(),
        turnstile_token: turnstileToken,
      };
      requestOtp(payload);
      updateOtpRequested(true);
    } else if (window.turnstile && !turnstileToken) {
      setErrorMessage('Please complete the Captcha verification.');
    }
  };

  return (
    <Fragment>
      <H3Text
        text="Enter your email address/ username, and we’ll send you a verification code."
        className="login__helper-text"
      />
      <Input
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="login__user-input"
        placeholder="Enter Your Username"
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            sendOtp();
          }
        }}
        style={{ marginBottom: '15px' }}
      />
      <div id="turnstile-element" style={{ display: (window.turnstile) ? 'block' : 'none' }} />

      {errorMessage && (
        <div className="verify-otp-error-wrapper" style={{ margin: '10px 0px 20px 0px' }}>
          <Alert
            type="error"
            showIcon
            message={errorMessage}
          />
        </div>
      )}
      <div className="login-button-wrapper">
        <H3Button
          text="Proceed to Login"
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          onClick={sendOtp}
          icon
          style={{ marginTop: '20px' }}
          isLoading={requestOtpLoading || requestOtpFastLoading}
        />
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  requestOtpLoading: UserReducers.requestOtpLoading,
  requestOtpFastLoading: UserReducers.requestOtpFastLoading,
  otpError: UserReducers.otpError,
});

const mapDispatchToProps = (dispatch) => ({
  requestOtp: (payload) => dispatch(UserActions.requestOtp(payload)),
  signupUserFast: (payload) => dispatch(UserActions.signupUserFast(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RequestOtp));
